import type { TechnicalInfoCategoryDTO, TechnicalInfoDataDTO } from "~/Search/dto/SearchResultsDTO";
import Grid from "@mui/material/Grid";
import { LinkList, LinkListItem } from "~/common/components/LinkList/LinkList"; // Grid version 2
import { useTranslation } from "react-i18next";
import { Stack } from "@mui/material";
import RenderServerSideContent from "~/common/components/RenderServerSideContent";

interface Props {
  data: TechnicalInfoDataDTO | null | undefined;
  cmsContent?: Element;
}

export const MoreInformationTab = (props: Props) => {
  const { t } = useTranslation();

  if (!props.data?.columns && !props.cmsContent) {
    return null;
  }

  const getLinkType = (openInNewTab: boolean, column: TechnicalInfoCategoryDTO) => {
    if (openInNewTab) {
      return "NEWTAB";
    }

    const isPublications = column?.title === t("more.info.column.PUBLICATIONS");
    return isPublications ? "DOWNLOAD" : "SAMETAB";
  };

  return (
    <Stack
      sx={{
        gap: 8,
      }}
    >
      <Grid container rowSpacing={3}>
        {props.cmsContent && (
          <Grid size={12}>
            <RenderServerSideContent content={props.cmsContent} />
          </Grid>
        )}
        {props.data?.columns?.map((column) => (
          <Grid
            size={{
              phone: 12,
              "desktop-s": 4,
            }}
          >
            <LinkList key={column.title} title={column.title} seeMoreUrl={column.viewMoreURL}>
              {column.items &&
                column.items.map((item) => (
                  <LinkListItem
                    key={item.name}
                    href={item.url}
                    headline={t(item.name)}
                    subheadline={item.assetTypeLabel ? t(item.assetTypeLabel) : t(item.subheader)}
                    overline={t(item.overline)}
                    linkType={getLinkType(item.openInNewTab, column)}
                  />
                ))}
            </LinkList>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};
